import React from "react";
import PropTypes from "prop-types";
import { Modal } from "@sia/style-guide";
import EvaluationsMasterKeyModalContent from "./EvaluationsMasterKeyModalContent";
import useEvaluationsMasterKeyModal from "./useEvaluationsMasterKeyModal";
import "./EvaluationsMasterKeyModal.scss";

const EvaluationsMasterKeyModal = ({ translate, redirectUrl, onAuthenticated, onContinueWithoutKey }) => {
  const workflow = useEvaluationsMasterKeyModal({ translate, redirectUrl, onAuthenticated, onContinueWithoutKey });
  const enterMode = workflow.masterKeyMode === "enter-key";
  const confirmLabel = translate("benchmarking.evaluations.master-key-modal.save");

  return (
    <div className="master-key-modal" id="evaluationMasterKeyModal">
      <Modal
        title={translate(
          enterMode ? "benchmarking.evaluations.master-key-modal.title" : `benchmarking.master-key-modal.title.${workflow.masterKeyMode}`
        )}
        lead={translate(
          enterMode ? "benchmarking.evaluations.master-key-modal.lead" : `benchmarking.master-key-modal.lead.${workflow.masterKeyMode}`
        )}
        formElement={
          <form
            onSubmit={(event) => {
              event.preventDefault();
              void workflow.handleSubmit();
            }}
          >
            <EvaluationsMasterKeyModalContent
              translate={translate}
              masterKeyMode={workflow.masterKeyMode}
              enteredKey={workflow.enteredKey}
              oldKey={workflow.oldKey}
              newKey={workflow.newKey}
              invalidText={workflow.invalidText}
              invalidTextOldKey={workflow.invalidTextOldKey}
              onEnteredKeyChange={workflow.handleEnteredKeyChange}
              onOldKeyChange={workflow.handleOldKeyChange}
              onNewKeyChange={workflow.handleNewKeyChange}
              onModeChange={workflow.handleModeChange}
            />
            <button type="submit" hidden tabIndex={-1}>
              {confirmLabel}
            </button>
          </form>
        }
        confirmLabel={confirmLabel}
        onConfirm={workflow.handleSubmit}
        cancelLabel={translate(
          enterMode ? "benchmarking.evaluations.master-key-modal.proceed-without-master-key" : "benchmarking.master-key-modal.secondary-button.cancel"
        )}
        onCancel={workflow.handleCancel}
      />
    </div>
  );
};

EvaluationsMasterKeyModal.propTypes = {
  translate: PropTypes.func.isRequired,
  redirectUrl: PropTypes.string,
  onAuthenticated: PropTypes.func,
  onContinueWithoutKey: PropTypes.func,
};

export default EvaluationsMasterKeyModal;
